import { createClient } from '@supabase/supabase-js';

// Use hardcoded values from database_instructions or fall back to null
const SUPABASE_URL = 'https://fxtdknmppvooqjbacprf.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ4dGRrbm1wcHZvb3FqYmFjcHJmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM2ODU0MzIsImV4cCI6MjA0OTI2MTQzMn0.33coEv0hhKIzLjPyVujGBAMs6X3EtZzZTvNNINA8EuY';

// Create the client if credentials are available
export const supabase = SUPABASE_URL && SUPABASE_ANON_KEY 
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: true,
        autoRefreshToken: true
      }
    })
  : null;

// Log connection status
if (supabase) {
  console.log('✅ Supabase client initialized successfully');
} else {
  console.warn('⚠️ Supabase client not initialized - missing credentials');
}